import React, { useState } from "react";
import AuthPage from "../layouts/SelfServeAuthPage";
import { Box, TextField, Typography } from "@mui/material";
import Link from "../components/Link";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { initiatePasswordReset } from "../clients/FixieApiClient";
import EmailImage from "../images/empty-logs.png";

interface PasswordResetFormValues {
  email: string
}

export default () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { register, handleSubmit } = useForm<PasswordResetFormValues>();

  const onSubmit = async (data: PasswordResetFormValues) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await initiatePasswordReset(data.email);
      if (response.ok) {
        setIsSuccess(true);
      }
    } finally {
      setIsLoading(false);
    }
  }

  if (isSuccess) {
    return (
      <AuthPage>
        <Box textAlign="center">
          <img src={EmailImage} alt="" style={{
            width: '256px',
            height: '256px',
            marginBottom: '1rem'
          }} />
          <Typography variant="body1">Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.</Typography>
        </Box>
      </AuthPage>
    )
  }
  return (
    <AuthPage>
      <Box>
        <Typography variant="body1">Enter the email you used to create your account and we’ll send you a link to reset your password.</Typography>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            fullWidth
            autoFocus
            margin="normal"
            label="Email"
            type="email"
            variant="outlined"
            {...register("email")}
          />
          <LoadingButton
            loading={isLoading}
            disableElevation
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 2, mb: 2, height: "56px" }}
          >
            <span>Continue</span>
          </LoadingButton>
        </Box>
        <Typography variant="body2">Don’t have an account? <Link to="/signup" variant="body2" style={{ textDecoration: "none" }}>
          Sign up
        </Link>
        </Typography>
      </Box>
    </AuthPage>
  );
};
